export default {
  name: 'marketing-consent',
  props: {
    // { email: Boolean, sms: Boolean, messengers: Boolean }
    value: {
      type: Object,
      required: true,
    },
    // The channels the published revision carries a wording for, already in the order they are
    // shown in. Each one is { key, apiKey, field, text }.
    channels: {
      type: Array,
      required: true,
    },
    // Optional: the revision may carry no heading, and then none is shown.
    title: {
      type: String,
      default: '',
    },
  },
  methods: {
    toggle(key, checked) {
      this.$emit('input', { ...this.value, [key]: checked })
    },
  },
}
